// 查询条件过滤类型集合
const likeType = ['%%','!%','==','!=','>=','<=','>','<','=%','%=','NN','!N']
const likeTypeTitle = ['包含','不包含','等于','不等于','大于等于','小于等于','大于','小于','开头是','结尾是','为空','不为空']
const likeTypes = {'%%':'包含','!%':'不包含','==':'等于','!=':'不等于','>=':'大于等于','<=':'小于等于','>':'大于','<':'小于','=%':'开头是','%=':'结尾是','NN':'为空','!N':'不为空'}
const sex = {'0':'女', '1':'男'}
const yesOrno = {'0':'否', '1':'是'}
const existsType = {'0':'无效', '1':'有效'}

export default {
    likeType,
    likeTypeTitle,
    likeTypes,
    sex,
    yesOrno,
    existsType
}


// WEBPACK FOOTER //
// ./src/api/jrglobal.js